import { FolderSimple, Square, CheckSquare } from "@phosphor-icons/react";
import { fileIcon, fmtBytes, fmtRelDate } from "./util.jsx";

export default function GridView({ contents, selectedFiles, selectedFolders, onToggleFile, onToggleFolder, onOpenFolder, onDownload }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-testid="grid-view">
      {contents.folders.map((d) => (
        <GridFolder key={d.id} d={d} selected={selectedFolders.has(d.id)} onToggle={() => onToggleFolder(d.id)} onOpen={() => onOpenFolder(d.id)} />
      ))}
      {contents.items.map((f) => (
        <GridFile key={f.id} f={f} selected={selectedFiles.has(f.id)} onToggle={() => onToggleFile(f.id)} onDownload={() => onDownload(f)} />
      ))}
    </div>
  );
}

function GridFolder({ d, selected, onToggle, onOpen }) {
  return (
    <div onClick={onOpen} className={`border border-black/10 rounded-md p-3 hover:border-black/30 hover:shadow-sm cursor-pointer transition ${selected ? "ring-2 ring-[#FF3366]" : ""}`} data-testid={`grid-folder-${d.id}`}>
      <div className="flex items-center justify-between mb-2">
        <FolderSimple size={28} weight="fill" className="text-[#FFA000]"/>
        <button onClick={(e) => { e.stopPropagation(); onToggle(); }} className="text-black/40 hover:text-black p-1">
          {selected ? <CheckSquare size={16} weight="fill" className="text-[#FF3366]"/> : <Square size={16}/>}
        </button>
      </div>
      <div className="font-medium text-sm truncate">{d.name}</div>
      <div className="text-[11px] font-mono text-black/50 mt-1">{fmtRelDate(d.created_at)}</div>
    </div>
  );
}

function GridFile({ f, selected, onToggle, onDownload }) {
  return (
    <div onDoubleClick={onDownload} className={`border border-black/10 rounded-md p-3 hover:border-black/30 hover:shadow-sm cursor-pointer transition ${selected ? "ring-2 ring-[#FF3366]" : ""}`} data-testid={`grid-file-${f.id}`}>
      <div className="flex items-center justify-between mb-2">
        {fileIcon(f.filename, f.content_type, 28)}
        <button onClick={(e) => { e.stopPropagation(); onToggle(); }} className="text-black/40 hover:text-black p-1">
          {selected ? <CheckSquare size={16} weight="fill" className="text-[#FF3366]"/> : <Square size={16}/>}
        </button>
      </div>
      <div className="font-medium text-sm truncate">{f.filename}</div>
      <div className="text-[11px] font-mono text-black/50 mt-1">{fmtBytes(f.size)}</div>
    </div>
  );
}
